import { render } from "./editClient.vue?vue&type=template&id=d3de4a7a&scoped=true"
import script from "./editClient.vue?vue&type=script&lang=js"
export * from "./editClient.vue?vue&type=script&lang=js"

import "./editClient.vue?vue&type=style&index=0&id=d3de4a7a&scoped=true&lang=css"

import exportComponent from "/var/www/html/heritage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3de4a7a"]])

export default __exports__